// extracted by mini-css-extract-plugin
module.exports = {"container":"_3BVBMAckjK9LuFszWXnEpv","visible":"_3UoeuGB_VlLWXv9XyTd7kc","cancelBtn":"_2r064wiiDklQ-Sg_CIcn0l","icon":"_3135rkqSU-MpdY6Oo9l8om","saveBtn":"_2q7fqlYsXL052-Pf8Ikq4H"};